module.exports = __webpack_public_path__ + "static/media/banner-phone-mobile.6c2ac3ab.png";